import {Component, Inject, OnInit, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {DialogPopupInteface} from '../../../core/interfaces/dialog-popup.interface';
import {MatomoService} from '../../../core/services/matomo.service';
import {DialogRestService} from '../../../core/services/api/dialog.rest-service';
import {takeUntil} from 'rxjs/operators';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-agb-popup',
  templateUrl: './agb-popup.component.html',
  styleUrl: './agb-popup.component.scss',
  standalone: false
})
export class AgbPopupComponent {
  private ngUnsubscribe$ = new Subject<void>();
  public subscribed = false;
  public parsedBody = [];
  public sent = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogPopupInteface,
              private dialogRef: MatDialogRef<AgbPopupComponent>,
              private matomoService: MatomoService,
              private dialogRestService: DialogRestService) {
    this.parseBody(data.body);
  }

  ngOnInit(): void {
  }

  private parseBody(body: string) {
    this.parsedBody = [];
    if (body !== undefined) {
      const matches = body.match(/\[form=([0-9]*)\]/g);
      if (matches) {
        for (const match of matches) {
          const split = body.split(match);
          this.parsedBody.push({data: split[0], type: 'string'});
          this.parsedBody.push({data: match.replace(/\D/g, '').trim(), type: 'form'});
          if (split.length > 1) {
            this.parsedBody.push({data: split[1], type: 'string'});
          }
        }
      } else {
        this.parsedBody.push({data: body, type: 'string'});
      }
    }
  }

  onSuccess($event: any) {
    this.sent = $event;

    if(this.data.subscription) {
      this.onSubscribe(this.data.title, this.data.idf);
    }
  }

  onSubscribe(name,idf: String) {
    this.dialogRestService.subscribeToDialogOffer(this.data.id, idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
      if (res.return_object !== null && res.error_code === null) {
        this.subscribed = true;
      }
    });
    this.matomoService.trackEvent('FEATUREBEZOGENE KPIs', 'Klick auf AGB Popup', name, 1);
  }

  ngOnDestroy(){
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
